const sliders = async function () {
    const heroSlider = document.querySelectorAll('.hero-slider') !== null;
    const carouselLogo = document.querySelectorAll('.carousel-logo') !== null;
    const carouselProjects = document.querySelectorAll('.carousel-projects') !== null;
    const carouselTestimonials = document.querySelectorAll('.carousel-testimonials') !== null;

    // // Execute code if You really need it
    if (heroSlider || carouselLogo || carouselProjects || carouselTestimonials) {
        let SwiperLib = await import('swiper/bundle');
        let Swiper = SwiperLib.default;

        if (heroSlider) {
            const heroSliderSwiper = new Swiper('.hero-slider', {
                lazy: false,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                effect: 'fade',
                simulateTouch: false,
                autoplay: {
                    delay: 5000,
                },
                speed: 2000,
                pagination: {
                    el: '.hero-slider__pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });
        }

        if (carouselLogo) {
            const carouselLogoSwiper = new Swiper('.carousel-logo', {
                slidesPerView: 2,
                spaceBetween: 75,
                loop: false,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 75,
                    },
                    1024: {
                        spaceBetween: 100,
                    },
                }
            });
        }

        if (carouselTestimonials) {
            document.querySelectorAll('.carousel-testimonials').forEach(el => {
                let carouselTestimonialSwiper = new Swiper(el, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },

                });

                const prevBtn = el.querySelector('.carousel-testimonials__nav__prev'),
                    nextBtn = el.querySelector('.carousel-testimonials__nav__next');

                if (prevBtn != null) {
                    prevBtn.addEventListener('click', () => {
                        carouselTestimonialSwiper.slidePrev()
                    }, false);
                }

                if (nextBtn != null) {
                    nextBtn.addEventListener('click', () => {
                        carouselTestimonialSwiper.slideNext()
                    }, false);
                }
            });
        }

        if (carouselProjects) {
            const breakpoint = window.matchMedia('(min-width:768px)');
            let carouselProjectsSwiper;

            const breakpointChecker = function () {
                if (breakpoint.matches == false) {
                    if (carouselProjectsSwiper !== undefined) carouselProjectsSwiper.destroy(true, true);
                    return;
                } else if (breakpoint.matches == true) {
                    return enableSwiper();
                }
            };

            const enableSwiper = function () {
                carouselProjectsSwiper = new Swiper('.carousel-projects', {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    loop: false,
                    mousewheel: true,
                });
            };

            breakpointChecker();
            breakpoint.addEventListener("change", () => {
                breakpointChecker();
            });
        }
    }
}

export const init = sliders;